/**
 *
 * OrganizationPage
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import {
  DAEMON,
  ROLE_AMBASSADOR,
  ROLE_COMPANY_ADMIN,
  ROLE_COMPANY_SUPER_ADMIN,
} from "utils/constants"
import { compose } from "redux"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import { Link } from "react-router-dom"
import xIcon from "../../images/x.svg"
import alertRedTriangle from "../../images/alert-red-triangle.svg"
import Onboarding from "components/Onboarding"

import { makeSelectCreateModal, makeSelectIsLoadingVismaPeopleStatus, makeSelectMeditions,makeSelectMeditionsOfficialized, makeSelectVismaPeopleStatus } from "./selectors"
import {
  clearTableWatcher,
  toggleCreateModal,
  getMeditions,
  submitFeedbackSurvey,
  dismissFeedbackSurvey,
  getVismaPeopleStatusWatcher,
} from "./actions"
import { slice, isEqual } from "lodash"

import reducer from "./reducer"
import saga from "./saga"

import {
  Button,
  Tooltip,
  Tabs,
  Dropdown,
  Menu,
  Popover,
  Modal,
  Input,
  Row,
} from "antd"
const { TextArea } = Input
import {
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons"
import { getTemplateDivision } from "../Division/actions"
import { makeSelectHasDivisions } from "../Division/selectors"

import { getTemplateCollaboratorsWatcher } from "../Collaborators/actions"
import {
  makeSelectHasCollaborators,
  makeSelectGetCollaborators,
} from "../Collaborators/selectors"

import deleteSvg from "../../images/delete.svg"
import Division from "../Division"
import Collaborators from "../Collaborators"

import "./index.less"
import { woopraTrack } from "../../utils/woopra/woopraTracker"
import {
  getItem,
  LOCAL_ACTIVE_ROL,
  LOCAL_USER_ID,
  LOCAL_USER_NAME,
  LOCAL_USER_EMAIL,
  SHOWED_FEEDBACK_SURVEY,
  LOCAL_ACTIVE_ROL_NAME,
  LOCAL_COMPANY_NAME,
  LOCAL_COMPANY_HUBSPOT,
  LOCAL_COMPANY_COUNTRY,
  LOCAL_ONBOARDING,
  LOCAL_PDA_IA_ENABLED,
  LOCAL_NEW_PDA_IA_NOTIFICATION,
  LOCAL_VISMA_PEOPLE_SYNC_ENABLED,
} from "../../utils/storage"
import { initializeSurvicateVisitor } from "../../utils/survicate"
import Select from "react-select/lib/Select"
import ModalPdaIaNotification from "../../components/ModalPdaIaNotification"

const TabPane = Tabs.TabPane

/* eslint-disable react/prefer-stateless-function */
export class OrganizationPage extends React.Component {
  state = {
    modalDelete: false,
    showAlert: false,
    showVismaPeopleErrorAlert: false,
    showCollaboratorsWithoutDivisionAlert: false,
    collaboratorsWithoutDivisionCount: 0,
    createModal: false,
    tabSelected: "divisions",
    modalDeleteDivisions: false,
    modalDeleteCollaborators: false,
    buttonDeleteDivisions: false,
    buttonDeleteCollaborators: false,
    surveyStep: 1,
    surveyVisible: false,
    surveyResponse: { score: 0, comments: "" },
    isModalVisible: true

  }
  constructor(props) {

    super(props)
    
    /* setTimeout(() => {
      this.setState({
        surveyVisible:
          localStorage.getItem(SHOWED_FEEDBACK_SURVEY) === "true"
            ? false
            : true,
      })
    }, 3000) */
    setTimeout(() => {
      this.setState({
        surveyVisible:
          false,
      })
    }, 0)
  }
  componentDidUpdate(prevProps) {

    if (
      this.props.location.hash === "#collaborators" &&
      this.state.tabSelected != "collaborators"
    ) {
      return this.setState({ tabSelected: "collaborators" })
    }

    //
    if (
      Array.isArray(this.props.meditions) &&
      this.props.meditions.length > 0 &&
      !isEqual(prevProps.meditions, this.props.meditions)
    ) {
      this.setState({
        showAlert: true,
      })

    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if(nextProps.vismaPeopleStatus !== this.props.vismaPeopleStatus) {
      this.handleVismaPeopleStatusChange(nextProps.vismaPeopleStatus)
    }
  }

  UNSAFE_componentWillMount = () => {

    let isAmbassador = LOCAL_ACTIVE_ROL() == ROLE_AMBASSADOR
    let isAdministrator = !!(
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_SUPER_ADMIN ||
      LOCAL_ACTIVE_ROL() == ROLE_COMPANY_ADMIN
    )

  }

  componentDidMount() {
    initializeSurvicateVisitor({
      user_id: LOCAL_USER_ID(),
      email: LOCAL_USER_EMAIL(),
      stage: process.env.APP_ENV,
      company: LOCAL_COMPANY_NAME(),
      role: LOCAL_ACTIVE_ROL_NAME(),
      hubspot: LOCAL_COMPANY_HUBSPOT(),
      user_country: LOCAL_COMPANY_COUNTRY(),
    })

    this.props.getMeditions({})

    if(LOCAL_VISMA_PEOPLE_SYNC_ENABLED()) {
      this.props.getVismaPeopleStatusWatcher()
    }
  }

  componentWillUnmount = () => {
    if (this.props.location.hash === "") {
      return this.setState({ tabSelected: "divisions" })
    }

    this.setState({
      tabSelected: slice(this.props.location.hash, 1).join(""),
    })
  }

  toggleModal = (modal, state) => {
    this.setState({
      [modal]: state,
    })
  }
  setVisible = (visible) => {
    this.setState({ isModalVisible: visible });
  }
  
  changeTab = (key) => {

    if(LOCAL_VISMA_PEOPLE_SYNC_ENABLED() && key === "collaborators") {
      this.props.getVismaPeopleStatusWatcher()
    }

    if(this.props.vismaPeopleStatus) {
      this.handleVismaPeopleStatusChange(this.props.vismaPeopleStatus)
    }
    
    this.setState({
      tabSelected: key,
    })
    window.location.hash = key
  }

  handleCollaboratorsWithoutDivisionChange = (collaboratorsWithoutDivisionCount) => {
    this.setState({ showCollaboratorsWithoutDivisionAlert: true, collaboratorsWithoutDivisionCount })
  }

  handleVismaPeopleStatusChange = (status) => {
    if([1, 2, 3].includes(parseInt(status.type))) {
      this.setState({ showVismaPeopleErrorAlert: true })
    }
  }

  importCollaborators = () => {
    return (
      <Menu>
        <Menu.Item key="0">
          <Link
            to="/organization/collaborators/import?screen=collaborators"
            onClick={() => woopraTrack("Importar colaboradores")}>
            Colaboradores
          </Link>
        </Menu.Item>
        <Menu.Item key="1">
          <Link to="/organization/collaborators/import?screen=teams">
            Líderes
          </Link>
        </Menu.Item>
        <Menu.Item key="2">
          <Link to="/organization/collaborators/import?screen=ceased">
            Cesados
          </Link>
        </Menu.Item>
      </Menu>
    )
  }

  renderButtonAddEmployee = () => {
    const countEmployees = this.props.collaborators.length
    const freemium = window.freemium()
    if (freemium && freemium.maxEmployees <= countEmployees) {
      return (
        <Popover
          content={
            <div style={{ maxWidth: 220 }}>
              <p>
                La cantidad de colaboradores ha alcanzado el máximo disponible.
              </p>
              <span className="color-gray-low" style={{ fontSize: 12 }}>
                Máximo: {freemium.maxEmployees} colaboradores
              </span>
            </div>
          }
          placement="bottomLeft">
          <Button
            className="blueButton"
            disabled
            size="default"
            type="primary"
            icon={<PlusOutlined />}
          />
        </Popover>
      )
    }
    return (
      <Tooltip placement="top" title="Crear colaborador">
        <Button
          className="blueButton"
          size="default"
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => {
            woopraTrack("Crear colaborador")
            this.props.history.push("/organization/collaborators/create")
          }}
        />
      </Tooltip>
    )
  }

  renderButtonImportEmployee = () => {
    const countEmployees = this.props.collaborators.length
    const freemium = window.freemium()
    if (freemium && freemium.maxEmployees <= countEmployees) {
      return (
        <Popover
          content={
            <div style={{ maxWidth: 220 }}>
              <p>
                La cantidad de colaboradores ha alcanzado el máximo disponible.
              </p>
              <span className="color-gray-low" style={{ fontSize: 12 }}>
                Máximo: {freemium.maxEmployees} colaboradores
              </span>
            </div>
          }
          placement="bottomLeft">
          <Button
            className="blueButton"
            disabled
            size="default"
            icon={<UploadOutlined />}
          />
        </Popover>
      )
    }
    return (
      <Tooltip placement="top" title="Importar">
        <Dropdown overlay={this.importCollaborators()} trigger={["click"]}>
          <Button
            className="whiteButton"
            size="default"
            icon={<UploadOutlined />}
          />
        </Dropdown>
      </Tooltip>
    )
  }
  changeSurveyStep = (step) => {
    this.setState({ ...this.state, surveyStep: step })
  }
  saveSurveyScore = (score) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.score = score
    this.setState({ ...this.state, surveyResponse })
    this.changeSurveyStep(2)
  }
  saveSurveyComments = (comments) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.comments = comments
    this.setState({ ...this.state, surveyResponse })
    this.changeSurveyStep(3)
  }
  handleSurveyCommentsChange = (e) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.comments = e.target.value
    this.setState({ ...this.state, surveyResponse })
  }
  handleSurveyCommentsCancel = () => {
    if (this.state.surveyStep != 3) {
      this.props.dismissFeedbackSurvey()
    }
    localStorage.setItem(
      SHOWED_FEEDBACK_SURVEY,
      !(localStorage.getItem(SHOWED_FEEDBACK_SURVEY) === "true")
    ),
      this.setState({ ...this.state, surveyVisible: false })
  }
  render() {
    const isConditionMet =  LOCAL_ONBOARDING() && LOCAL_ONBOARDING() != "false" && JSON.parse(LOCAL_ONBOARDING()).some(item => 
      item.step > 5
   );
    return (
      <div>
         {(LOCAL_ONBOARDING() == "false" || isConditionMet )&& LOCAL_PDA_IA_ENABLED() && LOCAL_NEW_PDA_IA_NOTIFICATION() &&
          this.props.meditionsOfficialized.length > 0 &&
      <ModalPdaIaNotification visible={this.state.isModalVisible} setVisible={this.setVisible} />
    }
        <Onboarding section="organization" />
        
        <Helmet>
          <title>Organización</title>
          <meta name="description" content="Description of OrganizationPage" />
        </Helmet>
        <div className="LayoutContainer">
          <div
            style={{
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
            }}>
            {(this.state.showVismaPeopleErrorAlert && this.state.tabSelected === "collaborators") && (
              <div className="visma-people-error-alert">
                <span>
                  <img src={alertRedTriangle} style={{marginRight: 7, marginBottom: 4}} />
                  Se encontró un <b>error al sincronizar</b> los datos de los <b>colaboradores con Visma People</b>. Ingresa a <Link style={{ color: "#2694FC" }} to="/control-panel#synchronization">Panel de control - Sincronización</Link> para obtener más información.
                </span>
                <img
                  src={xIcon}
                  onClick={() => this.setState({ showVismaPeopleErrorAlert: false })}
                />
              </div>
            )}
            {this.state.showAlert && (
              <div className="measurement-details-alert">
                <span>
                  La medición <strong>{this.props.meditions[0].name}</strong> ha
                  finalizado. No olvides{" "}
                  <strong>oficializar los resultados</strong> para evitar que
                  cambios en el organigrama afecten la información recogida 😰.{" "}
                  <Button
                    onClick={() => {
                      this.props.history.push(
                        `reports/measure/${this.props.meditions[0].id_measure}?officialized=true`
                      )
                      // push('/reports/measure/' + this.props.meditions[0].id_measure)
                    }}>
                    Oficializar resultados
                  </Button>
                </span>
                <img
                  src={xIcon}
                  onClick={() => this.setState({ showAlert: false })}
                />
              </div>
            )}
            {this.state.showCollaboratorsWithoutDivisionAlert && (
              <div className="visma-people-collaborators-without-division-alert">
                <span>
                  Cuentas con <b>{this.state.collaboratorsWithoutDivisionCount} colaboradores sin divisiones asignadas</b>. Ingresa a <b>Organización - Colaboradores</b> para asignarles una e incluirlos en las diferentes mediciones. Para más información ingresa al <a style={{ color: '#2694FC' }} href="https://people.vismalatam.com" target="_blank">Help Center.</a>
                </span>
                <img
                  src={xIcon}
                  onClick={() => this.setState({ showCollaboratorsWithoutDivisionAlert: false })}
                />
              </div>
            )}
            <Modal
              centered
              visible={this.state.surveyVisible}
              footer={null}
              width={620}
              onCancel={this.handleSurveyCommentsCancel}>
              {this.state.surveyStep == 1 && (
                <>
                  <div className="survey-feedback">
                    <div className="title">
                      ¿Qué tan satisfecho te encuentras con el producto?*
                    </div>
                    <div className="container-button">
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(0)}>
                        0
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(1)}>
                        1
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(2)}>
                        2
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(3)}>
                        3
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(4)}>
                        4
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(5)}>
                        5
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(6)}>
                        6
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(7)}>
                        7
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(8)}>
                        8
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(9)}>
                        9
                      </div>
                      <div
                        className="button-qualify"
                        onClick={() => this.saveSurveyScore(10)}>
                        10
                      </div>
                    </div>
                  </div>
                </>
              )}
              {this.state.surveyStep == 2 && (
                <>
                  <div className="survey-feedback">
                    <div className="title">
                      ¿Qué podríamos hacer para mejorar?
                    </div>
                    <TextArea
                      rows={3}
                      placeholder="Nos encantaría escuchar tus sugerencias..."
                      onChange={this.handleSurveyCommentsChange}
                    />
                    <br />
                    <br />
                    <Row justify="space-between">
                      <Button
                        width={100}
                        onClick={() => this.changeSurveyStep(1)}>
                        {" "}
                        &lt;&nbsp;Anterior
                      </Button>
                      <Button
                        width={100}
                        type="primary"
                        onClick={() => {
                          this.props.submitFeedbackSurvey(
                            this.state.surveyResponse
                          )
                          this.changeSurveyStep(3)
                        }}>
                        {" "}
                        &nbsp;&nbsp;&nbsp;Enviar&nbsp;&nbsp;&nbsp;{" "}
                      </Button>
                    </Row>
                  </div>
                </>
              )}
              {this.state.surveyStep == 3 && (
                <>
                  <div className="survey-feedback">
                    <br></br>
                    <div
                      className="title"
                      style={{
                        width: "100%",
                        textAlign: "center",
                        paddingLeft: "25px",
                      }}>
                      ¡Gracias por el feedback 💙!
                    </div>
                  </div>
                </>
              )}
            </Modal>
            <div style={{ marginTop: "1rem" }}>
              <span
                style={{
                  marginLeft: "2rem",
                  color: "#555155",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
                className="title_section">
                Organización
              </span>
              <div style={{ position: "relative" }}>
                <Tabs
                  animated={false}
                  className="tabs"
                  activeKey={this.state.tabSelected}
                  onChange={this.changeTab}>
                  <TabPane tab="Divisiones" key="divisions">
                    {this.state.tabSelected === "divisions" && (
                      <Division
                        createModal={this.props.createModal}
                        getTemplateDivision={this.props.getTemplateDivision}
                        toggleCreateModal={this.props.toggleCreateModal}
                        modalDeleteDivisions={this.state.modalDeleteDivisions}
                        buttonDeleteDivisions={this.state.buttonDeleteDivisions}
                        toggleModal={this.toggleModal}
                      />
                    )}
                  </TabPane>
                  <TabPane tab="Colaboradores" key="collaborators">
                    {this.state.tabSelected === "collaborators" && (
                      <Collaborators
                        toggleModal={this.toggleModal}
                        changeTab={this.changeTab}
                        onCollaboratorsWithoutDivisionChange={this.handleCollaboratorsWithoutDivisionChange}
                        hasCollaborators={this.props.hasCollaborators}
                        vismaPeopleStatus={this.props.vismaPeopleStatus}
                        modalDeleteCollaborators={
                          this.state.modalDeleteCollaborators
                        }
                      />
                    )}
                  </TabPane>
                </Tabs>

               
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

OrganizationPage.propTypes = {
  getTemplateDivision: PropTypes.func.isRequired,
  getTemplateCollaborators: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  createModal: makeSelectCreateModal(),
  hasDivisions: makeSelectHasDivisions(),
  hasCollaborators: makeSelectHasCollaborators(),
  meditions: makeSelectMeditions(),
  meditionsOfficialized : makeSelectMeditionsOfficialized(),
  collaborators: makeSelectGetCollaborators(),
  vismaPeopleStatus: makeSelectVismaPeopleStatus(),
  isLoadingVismaPeopleStatus: makeSelectIsLoadingVismaPeopleStatus()
})

function mapDispatchToProps(dispatch) {
  return {
    getTemplateDivision: (params) => dispatch(getTemplateDivision(params)),
    getTemplateCollaborators: (params) =>
      dispatch(getTemplateCollaboratorsWatcher(params)),
    clearTable: () => dispatch(clearTableWatcher()),
    toggleCreateModal: (params) => dispatch(toggleCreateModal(params)),
    getMeditions: (params) => dispatch(getMeditions(params)),
    submitFeedbackSurvey: (params) => dispatch(submitFeedbackSurvey(params)),
    dismissFeedbackSurvey: (params) => dispatch(dismissFeedbackSurvey(params)),
    getVismaPeopleStatusWatcher: (params) => dispatch(getVismaPeopleStatusWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "organizationPage", reducer })
const withSaga = injectSaga({ key: "organizationPage", saga, mode: DAEMON })

export default compose(withReducer, withSaga, withConnect)(OrganizationPage)
